import Repository from './Repository'
const URL_GET_NOTIFICATION = `${process.env.MIX_NOTIFICATIONS_URL}?timestamp=` + Date.now()
const URL_GET_NOTIFICATION_OSAKA = '/notification-osaka/'
const URL_POST_UPLOAD_FILE = '/notification-osaka/upload-file'
const URL_GET_LIST_NOTIFICATIONS_FOR_MANAGEMENT = '/notification-osaka/admin'
const URL_GET_FILE_S3 = '/notification-osaka/get-file-s3'
export default {
  getNotifications (region) {
    if(region === 'region') {
      return Repository.get(URL_GET_NOTIFICATION_OSAKA)
    }
    else {
      return fetch(URL_GET_NOTIFICATION)
    }
  },
  putNotifications (id) {
    return Repository.put(URL_GET_NOTIFICATION_OSAKA+id)
  },
  getListNotificationForManagement() {
    return Repository.get(URL_GET_LIST_NOTIFICATIONS_FOR_MANAGEMENT)
  },
  getDetailNotificationForManagement(id) {
    return Repository.get(URL_GET_LIST_NOTIFICATIONS_FOR_MANAGEMENT+'?id='+id)
  },
  postUploadFiles(base64Files) {
    return Repository.post(URL_POST_UPLOAD_FILE, base64Files)
  },
  deleteDetailNotificationMangement(id) {
    return Repository.delete(URL_GET_NOTIFICATION_OSAKA+id)
  },
  updateNotificationMangement(payload) {
    return Repository.post(URL_GET_NOTIFICATION_OSAKA+payload.id, payload.data)
  },
  registerNotificationMangement(data) {
    return Repository.post(URL_GET_NOTIFICATION_OSAKA, data)
  },
  getFileFromS3(filePath) {
    return Repository.get(URL_GET_FILE_S3+'?filePath='+filePath)
  },
}
